import type { ServerErrorCode } from '@/interfaces/service/api.interface';
import { authValidationMessages } from '@/constants/vaildation.constants';

export const AUTH_ERROR: Record<string, ServerErrorCode> = {
  authenticationError: 'AUTH-001',
  authorizationError: 'AUTH-002',
  tokenNotFound: 'AUTH-003',
  accessTokenExpired: 'AUTH-004',
  incorrectOtp: 'AUTH-005',
  invalidToken: 'AUTH-006',
  authenticationRequired: 'AUTH-007',
  refreshTokenExpired: 'AUTH-010'
};

export const APP_USER_ID_ERROR: Record<string, ServerErrorCode> = {
  duplicatedId: 'USER-001',
  userNotFound: '90014'
};

export const ERROR_CODES_FROM_SERVER = ['AUTH-001', 'AUTH-002', 'AUTH-003', 'AUTH-004', 'AUTH-005', 'AUTH-006', 'AUTH-007', 'USER-001', 'USER-002'];

export const errorMessagesHasServerCode: Record<ServerErrorCode, string> = {
  'AUTH-005': authValidationMessages.otp.incorrect,
  'USER-001': authValidationMessages.email.duplicatedId,
  'USER-002': authValidationMessages.email.userNotFound
};

/**
 * 병원 등록 시 "이미 등록된 병원" 을 가리키는 서버 코드.
 *
 * 서버는 legacy 오류 봉투(`{errors, errorMessage, path, timeStamp}`)로 내려주며
 * 판정 근거는 `errors[0].code` 다. 판정값을 여기 한 곳에 모아 두어 서버 코드가 바뀌어도
 * 이 줄만 고치면 되게 한다.
 */
export const STORE_ALREADY_REGISTERED_CODE = 'STORE-001';

/** 필수 입력값이 빠졌을 때 서버가 돌려주는 코드. 병원 등록에서는 storeName 누락이 이 경우다. */
export const INVALID_REQUEST_CODE = 'COMMON-004';
